import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Close Icon Component
 * Simple X/cross symbol (outline style)
 * Used for close buttons and dismiss actions
 */
class CloseIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
            />
        `;
    }
}

customElements.define('close-icon', CloseIcon);
